import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import Navbar from "@/components/Navbar";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen island-pattern">
      <Navbar />
      <div className="max-w-xl mx-auto px-4 py-20 text-center">
        <div className="bg-white p-8 rounded-3xl border border-[#E5D9C5] shadow-[0_20px_60px_rgba(44,36,27,0.08)] slide-up" data-testid="payment-cancel-card">
          <XCircle className="w-14 h-14 mx-auto text-[#D9381E]" />
          <h1 className="mt-4 font-display font-extrabold text-3xl">Payment cancelled</h1>
          <p className="mt-2 text-[#7A6C5D]">Your cart is still saved. Try again anytime.</p>
          <Link to="/" data-testid="cancel-back-home-btn" className="mt-6 inline-block cta-primary rounded-full px-6 py-3 font-display font-extrabold text-sm">Back to menu</Link>
        </div>
      </div>
    </div>
  );
}
